import { z } from 'zod';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';
import { HoldingSchema } from '@/types/holding/holding.type.ts';
import { HoldingStatus } from '@/types/holding/holding-status.type.ts';

export type HoldingPaginatorItem = {
    id: number,
    sap_code: string,
    name: string,
    status: HoldingStatus,
    dealers_sap_codes: string | null,
    dealers_count: number | null,
};

export type HoldingsPaginator = {
    data: HoldingPaginatorItem[],
    meta: PaginationMeta,
};

export type HoldingsRequestFilter = {
    page?: number,
    name?: string,
    sap_code?: string,
    status?: HoldingStatus[],
    sort?: Record<string, string>[],
};

export const HoldingsSchema = z.array(HoldingSchema);

export const HoldingPaginatorItemSchema = z.object({
    id: z.number(),
    sap_code: z.string(),
    name: z.string(),
    status: z.nativeEnum(HoldingStatus),
    dealers_sap_codes: z.string().nullable(),
    dealers_count: z.number().nullable(),
});

export const HoldingsPaginatorSchema = z.object({
    data: z.array(HoldingPaginatorItemSchema),
    meta: PaginationMetaSchema,
});
